/* Bedtextielonline (Claude) - gedeelde werking op alle pagina's
   1. Upsell-kaartjes (productpagina): keuze uitvoering/maat -> juiste variant en prijs
   2. Suggesties in de winkelwagen: maat kiezen + toevoegen
   3. Carrousels (reviews): schuiven vanzelf, pauzeren bij aanraken, pijltjes
   4. Optienaam 'Title' tonen als 'Maat'
   5. 'Maak je set compleet': stappen en keuze van de matras
   6-7. Maat: herkennen, vergelijken en onthouden over de hele shop
   8. Kleur wisselen in de suggesties
   9. Aantal stuks bij het winkelwagen-icoon
  10. Losse swoosh tussen secties
  11. Productpagina: 'Maak je bed compleet' (zoals Smulders) + bijhouden in de bestelling */
(function () {
  /* ---------- 0. vaste stijl: staat nu in btol-globaal.css (laadt meteen in de head) ---------- */

  /* ---------- 0b. collectiepagina's: kop (keuzehulp of gewone collectiekop) met foto als achtergrond, zoals de homepage.
     Foto van de collectie; heeft de collectie er geen, dan de sfeerfoto van de homepage. ---------- */
  (function () {
    var pogingen = 0;
    function beeld() {
      var og = document.querySelector('meta[property="og:image"]');
      var u = (og && og.content) || '';
      if (u.indexOf('/collections/') < 0) u = 'https://badtextielonline.com/cdn/shop/files/Marthe_028_productlandscape_1_1752487456.jpg?width=1800';
      return u.replace(/^http:/, 'https:').replace(/^\/\//, 'https://').replace(/width=\d+/, 'width=1800');
    }
    function zet() {
      document.querySelectorAll('.btol-wiz__kop, .shopify-section--collection-banner .container').forEach(function (k) {
        if (k.__btolBg) return;
        k.style.setProperty('--btol-wiz-bg', 'url("' + beeld() + '")');
        k.__btolBg = true;
      });
    }
    /* lange collectietekst op gsm: 3 regels met 'Lees meer' (zoals bij de keuzehulp) */
    function meer() {
      document.querySelectorAll('.shopify-section--collection-banner .collection-description').forEach(function (d) {
        if (d.__btolMeer || d.closest('.btol-wiz__kop')) return;
        d.__btolMeer = true;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'btol-wiz__meer'; b.textContent = 'Lees meer'; b.hidden = true;
        b.addEventListener('click', function () { var o = d.classList.toggle('is-open'); b.textContent = o ? 'Lees minder' : 'Lees meer'; });
        d.insertAdjacentElement('afterend', b);
        function meet() { if (!d.classList.contains('is-open')) b.hidden = d.scrollHeight <= d.clientHeight + 2; }
        meet();
        window.addEventListener('resize', meet);
      });
    }
    zet(); meer();
    var t = setInterval(function () { zet(); meer(); if (++pogingen > 30) clearInterval(t); }, 400);
  })();

  /* ---------- 0c. winkelwagenpagina: leverbericht zonder emoji, in de huisstijl ---------- */
  (function () {
    var truck = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>';
    function levering() {
      document.querySelectorAll('.cart-recap > div[style*="border-left"]').forEach(function (d) {
        d.removeAttribute('style');
        d.className = 'btol-cart-levering';
        var s = d.querySelector('span');
        if (s) s.innerHTML = s.innerHTML.replace(/📦\s?/g, '');
        d.insertAdjacentHTML('afterbegin', truck);
      });
    }
    var bezig = false;
    function plan() { if (bezig) return; bezig = true; requestAnimationFrame(function () { bezig = false; levering(); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', levering); else levering();
    if (window.MutationObserver) new MutationObserver(plan).observe(document.documentElement, { childList: true, subtree: true });
  })();

  /* ---------- 1. upsell-kaartjes ---------- */
  if (!window.__btolUpsell) {
    window.__btolUpsell = true;
    var getData = function (card) {
      if (!card.__btolData) {
        var s = card.querySelector('script[data-btol-json]');
        try { card.__btolData = JSON.parse(s.textContent); } catch (e) { card.__btolData = { groups: [] }; }
      }
      return card.__btolData;
    };
    var currentGroup = function (card) {
      var d = getData(card);
      var gs = card.querySelector('select[data-btol-group]');
      var id = gs ? gs.value : (d.groups[0] ? String(d.groups[0].id) : '');
      return d.groups.find(function (g) { return String(g.id) === id; }) || d.groups[0];
    };
    var fill = function (card) {
      var g = currentGroup(card);
      if (!g) return;
      card.querySelectorAll('select[data-btol-opt]').forEach(function (sel) {
        var i = parseInt(sel.getAttribute('data-btol-opt'), 10);
        var prev = sel.value, vals = [];
        g.variants.forEach(function (v) { if (v.o[i] != null && vals.indexOf(v.o[i]) < 0) vals.push(v.o[i]); });
        sel.innerHTML = '';
        vals.forEach(function (x) { var o = document.createElement('option'); o.value = x; o.textContent = x; sel.appendChild(o); });
        if (vals.indexOf(prev) > -1) sel.value = prev;
      });
    };
    var apply = function (card) {
      var g = currentGroup(card);
      if (!g) return;
      var chosen = {};
      card.querySelectorAll('select[data-btol-opt]').forEach(function (s) { chosen[s.getAttribute('data-btol-opt')] = s.value; });
      var v = g.variants.find(function (x) {
        return Object.keys(chosen).every(function (i) { return x.o[i] === chosen[i]; });
      }) || g.variants[0];
      if (!v) return;
      var idInput = card.querySelector('[data-btol-id]');
      if (idInput) idInput.value = v.id;
      var price = card.querySelector('[data-btol-price]');
      if (price) price.textContent = v.p;
      var btn = card.querySelector('[data-btol-button]');
      if (btn) btn.disabled = !v.a;
    };
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('select[data-btol-group], select[data-btol-opt]')) return;
      var card = t.closest('[data-btol-card]');
      if (!card) return;
      if (t.matches('[data-btol-group]')) fill(card);
      apply(card);
    });
  }

  /* ---------- 1b. upsell-kaartje: titel, link en foto wisselen mee met de hoekhoogte ---------- */
  if (!window.__btolUpsellKop) {
    window.__btolUpsellKop = true;
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('select[data-btol-group]')) return;
      var card = t.closest('[data-btol-card]');
      var s = card && card.querySelector('script[data-btol-json]');
      if (!s) return;
      var d; try { d = JSON.parse(s.textContent); } catch (err) { return; }
      var g = (d.groups || []).find(function (x) { return String(x.id) === String(t.value); });
      if (!g || !g.t) return;
      var titel = card.querySelector('.product-title');
      if (titel) { titel.textContent = g.t; if (g.u) titel.href = g.u; }
      var fig = card.querySelector('.horizontal-product-card__figure');
      if (fig && g.u) fig.href = g.u;
      var img = card.querySelector('.horizontal-product-card__image');
      if (img && g.img) { img.removeAttribute('srcset'); img.src = g.img; img.alt = g.t; }
    });
  }

  /* ---------- 2. winkelwagen-suggestie ---------- */
  document.addEventListener('change', function (e) {
    var s = e.target && e.target.closest && e.target.closest('[data-btol-cs-select]');
    if (!s) return;
    var card = s.closest('[data-btol-cs]');
    var o = s.options[s.selectedIndex];
    var knop = card.querySelector('[data-btol-cs-add]');
    if (knop) { knop.setAttribute('data-btol-cs-add', s.value); knop.disabled = !!o.disabled; }
    var p = card.querySelector('[data-btol-cs-prijs]');
    if (p && o.getAttribute('data-prijs')) p.textContent = o.getAttribute('data-prijs');
  });
  if (!window.btolCsInit) {
    window.btolCsInit = true;
    document.addEventListener('click', async function (e) {
      var knop = e.target.closest && e.target.closest('[data-btol-cs-add]');
      if (!knop) return;
      e.preventDefault();
      var tekst = knop.querySelector('.btol-cs__knop-tekst') || knop;
      knop.setAttribute('aria-busy', 'true');
      tekst.textContent = 'Toevoegen…';
      try {
        var res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(knop.getAttribute('data-btol-cs-add')), quantity: 1 }] })
        });
        if (!res.ok) throw new Error('add');
        tekst.textContent = 'Toegevoegd';
        var kaartje = knop.closest('[data-btol-cs]'), keuze = kaartje && kaartje.querySelector('[data-btol-cs-select]'), stapje = knop.closest('.btol-sug__kaart');
        var naam = kaartje && kaartje.querySelector('.btol-cs__titel') ? kaartje.querySelector('.btol-cs__titel').textContent.trim() : '';
        var maatje = keuze && keuze.options[keuze.selectedIndex] ? ' ' + maatTekst(keuze.options[keuze.selectedIndex].text) : '';
        await btolLog('Winkelwagen' + (stapje && stapje.getAttribute('data-btol-stap') ? ' (' + stapje.getAttribute('data-btol-stap') + ')' : '') + ': ' + naam + maatje);
        if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(location.pathname)) { location.reload(); return; }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (err) {
        knop.removeAttribute('aria-busy');
        tekst.textContent = 'Toevoegen';
      }
    });
  }

  /* ---------- 3. carrousels ---------- */
  function stap(c, richting) {
    var eerste = c.firstElementChild;
    if (!eerste) return;
    var breedte = eerste.getBoundingClientRect().width + (parseFloat(getComputedStyle(c).columnGap) || 0);
    var max = c.scrollWidth - c.clientWidth - 2;
    var doel = c.scrollLeft + richting * breedte;
    if (doel > max + 1) doel = 0;
    if (doel < -1) doel = max;
    c.scrollTo({ left: doel, behavior: 'smooth' });
  }
  setInterval(function () {
    document.querySelectorAll('[data-btol-carrousel]').forEach(function (c) {
      if (c.offsetParent === null || c.scrollWidth <= c.clientWidth + 2) return;
      if (c.matches(':hover') || (c.__btolPauze && Date.now() < c.__btolPauze)) return;
      stap(c, 1);
    });
  }, 5000);
  document.addEventListener('touchstart', function (e) {
    var c = e.target.closest && e.target.closest('[data-btol-carrousel]');
    if (c) c.__btolPauze = Date.now() + 10000;
  }, { passive: true });
  document.addEventListener('click', function (e) {
    var p = e.target.closest && e.target.closest('[data-btol-pijl]');
    if (!p) return;
    var c = p.closest('.btol-pv__carrousel');
    c = c && c.querySelector('[data-btol-carrousel]');
    if (!c) return;
    c.__btolPauze = Date.now() + 10000;
    stap(c, parseInt(p.getAttribute('data-btol-pijl'), 10));
  });

  /* ---------- 4. optienaam 'Title' (standaardnaam van Shopify) tonen als 'Maat' bij de aanvullende producten ---------- */
  function titelMaat() {
    document.querySelectorAll('.btol-picker label > span').forEach(function (s) {
      if (s.textContent.trim().toLowerCase() === 'title') s.textContent = 'Maat';
    });
  }
  titelMaat();
  var tm = 0, tmt = setInterval(function () { titelMaat(); if (++tm > 12) clearInterval(tmt); }, 800);

  /* ---------- 5. 'Maak je set compleet' (winkelwagen): naar een stap gaan met de knopjes bovenaan.
     Na toevoegen opent vanzelf de volgende stap (de winkelwagen wordt opnieuw opgebouwd). ---------- */
  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-btol-stap-knop]');
    if (!k) return;
    var box = k.closest('.btol-cz, .btol-cp-sug, .btol-cart-suggestie');
    var lijst = box && box.querySelector('[data-btol-stappen]');
    if (!lijst) return;
    e.preventDefault();
    var key = k.getAttribute('data-btol-stap-knop');
    lijst.querySelectorAll('.btol-sug__kaart').forEach(function (c) { c.classList.toggle('is-actief', c.getAttribute('data-btol-stap') === key); });
    box.querySelectorAll('[data-btol-stap-knop]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-btol-stap-knop') === key ? 'true' : 'false'); });
  });

  /* hoeslaken in de trechter: keuze standaard / extra hoog / topper (onthouden, net als op de productpagina) */
  function hhZet(kaart, g) {
    if (!kaart.querySelector('[data-btol-hh-opt="' + g + '"]')) return;
    kaart.querySelectorAll('[data-btol-hh-opt]').forEach(function (o) { o.classList.toggle('is-actief', o.getAttribute('data-btol-hh-opt') === g); });
    kaart.querySelectorAll('[data-btol-hh-knop]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-btol-hh-knop') === g ? 'true' : 'false'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-btol-hh-knop]');
    if (!b) return;
    e.preventDefault();
    var g = b.getAttribute('data-btol-hh-knop');
    document.querySelectorAll('[data-btol-hh]').forEach(function (k) { hhZet(k, g); });
    try { localStorage.setItem('btol_ups', g); } catch (err) {}
  });
  /* meerdere dekbedovertrekken in de winkelwagen: wisselen tussen de hoeslaken-blokken met de fotoknopjes */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-btol-voor-knop]');
    if (!b) return;
    e.preventDefault();
    var kaart = b.closest('.btol-sug__kaart'), nr = b.getAttribute('data-btol-voor-knop');
    if (!kaart) return;
    kaart.querySelectorAll('[data-btol-voor]').forEach(function (v) { v.classList.toggle('is-actief', v.getAttribute('data-btol-voor') === nr); });
    kaart.querySelectorAll('[data-btol-voor-knop]').forEach(function (k) { k.setAttribute('aria-pressed', k === b ? 'true' : 'false'); });
  });
  function hhOnthoud() {
    var g = null;
    try { g = localStorage.getItem('btol_ups'); } catch (err) {}
    if (!g) return;
    document.querySelectorAll('[data-btol-hh]').forEach(function (k) { if (!k.__btolHh) { k.__btolHh = true; hhZet(k, g); } });
  }
  hhOnthoud();
  if (window.MutationObserver) new MutationObserver(function () { hhOnthoud(); }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- 6. hulpfuncties voor de maat (trechter, upsell en productpagina) ---------- */
  /* een maat-tekst kan meerdere maten bevatten, bv. '140 x 200 cm - 120/130 x 200 cm' (stretch) of '240 x 200/220 cm + 2 kussenslopen' */
  function maatDelen(t) {
    t = String(t || '').toLowerCase();
    var m = t.match(/\(([^)]*)\)/); if (m) t = m[1];
    t = t.replace(/cm/g, '').replace(/×/g, 'x');
    var uit = [];
    t.split(/\s+-\s+|,|;|\s+of\s+/).forEach(function (deel) {
      var d = deel.split('+')[0].split('x'); if (d.length < 2) return;
      var b = d[0].split('/').map(function (s) { return s.trim(); }).filter(Boolean);
      var l = d[1].split('/').map(function (s) { return s.trim(); }).filter(Boolean);
      if (b.length && l.length) uit.push({ b: b, l: l });
    });
    return uit.length ? uit : null;
  }
  function maatEen(a, b) {
    return a.b.some(function (x) { return b.b.indexOf(x) > -1; }) && a.l.some(function (x) { return b.l.indexOf(x) > -1; });
  }
  /* strikt: alleen de eerste (hoofd)maat van beide vergelijken */
  function maatPast(a, b, strikt) {
    if (!a || !b) return false;
    var A = strikt ? [a[0]] : a, B = strikt ? [b[0]] : b;
    return A.some(function (x) { return B.some(function (y) { return maatEen(x, y); }); });
  }
  /* beste keuze uit een lijst: exact dezelfde tekst, dan zelfde hoofdmaat, dan overlap */
  function besteMaat(lijst, tekstVan, t) {
    var doel = maatDelen(t), schoon = String(t || '').trim();
    lijst = lijst.filter(function (x) { return !x.disabled; });
    return lijst.find(function (x) { return maatTekst(tekstVan(x)) === schoon; }) ||
           lijst.find(function (x) { return maatPast(doel, maatDelen(tekstVan(x)), true); }) ||
           lijst.find(function (x) { return maatPast(doel, maatDelen(tekstVan(x))); }) || null;
  }
  function optTekst(o) { return o.text; }
  function kaartBij(card, sel) {
    var o = sel.options[sel.selectedIndex]; if (!o) return;
    var knop = card.querySelector('[data-btol-cs-add]');
    if (knop) { knop.setAttribute('data-btol-cs-add', sel.value); knop.disabled = !!o.disabled; }
    var p = card.querySelector('[data-btol-cs-prijs]');
    if (p && o.getAttribute('data-prijs')) p.textContent = o.getAttribute('data-prijs');
  }
  function kiesMaat(sel, tekst) {
    var keuze = besteMaat(Array.prototype.slice.call(sel.options), optTekst, tekst);
    if (keuze && sel.value !== keuze.value) { sel.value = keuze.value; kaartBij(sel.closest('[data-btol-cs]'), sel); }
  }
  /* ---------- 7. maatgeheugen over de hele shop ----------
     Standaard rekenen we de maat zelf uit (bv. dekbedovertrek 260 -> hoeslaken 180 x 200).
     Kiest de klant ergens zelf een maat (productpagina, 'Maak je set compleet' op de productpagina, de trechter in de winkelwagen),
     dan onthouden we die (localStorage) en die gaat overal voor. Drie aparte geheugens:
     matras (hoeslaken, topper hoeslaken, matrasbeschermer), dekbed (dekbed en dekbedovertrek) en kussen. */
  var MAAT_KEY = { matras: 'btol_maat_matras', dekbed: 'btol_maat_dekbed', kussen: 'btol_maat_kussen' };
  var MAAT_RE = /\d+\s*(?:\/\s*\d+\s*)*[x×]\s*\d+/i;
  function domeinVanTekst(t) {
    t = String(t || '').toLowerCase();
    if (/lakenset|badlaken|handdoek|plaid|sprei/.test(t)) return null;
    if (/dekbed/.test(t)) return 'dekbed';
    if (/kussen|sloop/.test(t)) return 'kussen';
    if (/hoeslaken|beschermer|molton|topper/.test(t)) return 'matras';
    return null;
  }
  function domeinVan(el) {
    var k = el.closest('.btol-sug__kaart');
    var s = k && k.getAttribute('data-btol-stap');
    if (s === 'hoeslaken' || s === 'beschermer') return 'matras';
    if (s === 'dekbed') return 'dekbed';
    if (s === 'kussen') return 'kussen';
    var c = el.closest('[data-btol-cs], [data-btol-card]');
    var t = c && c.querySelector('.btol-cs__titel, .product-title');
    return domeinVanTekst(t ? t.textContent : '');
  }
  /* dekbed: bij een maat met 200/220 (zoals bij een dekbedovertrek) standaard de lengte 220, behalve 200 breed (200 x 200) */
  function dekbedVoorkeur(t) {
    var d = maatDelen(t); if (!d) return t;
    var m = d[0];
    if (m.l.indexOf('200') < 0 || m.l.indexOf('220') < 0) return t;
    var br = m.b[0];
    return br + ' x ' + (m.b.indexOf('200') > -1 ? '200' : '220');
  }
  function maatTekst(t) { return String(t || '').replace(/\s*\(uitverkocht\)\s*$/i, '').trim(); }
  function maatLees(d) { try { return d ? localStorage.getItem(MAAT_KEY[d]) : null; } catch (err) { return null; } }
  function maatBewaar(d, t) {
    t = maatTekst(t).split(/\s+-\s+/)[0].trim();
    if (!d || !MAAT_KEY[d] || !MAAT_RE.test(t)) return;
    try { localStorage.setItem(MAAT_KEY[d], t); } catch (err) {}
  }
  function maatOk(sel, t) {
    var beste = besteMaat(Array.prototype.slice.call(sel.options), optTekst, t);
    return !beste || beste === sel.options[sel.selectedIndex];
  }
  function maatSelect(card) {
    return Array.prototype.find.call(card.querySelectorAll('select[data-btol-opt]'), function (s) {
      return /maat|afmeting|title|size/i.test(s.getAttribute('aria-label') || '');
    });
  }
  /* klant kiest zelf een maat: onthouden en de andere kaartjes van hetzelfde soort meteen mee laten gaan */
  document.addEventListener('change', function (e) {
    if (!e.isTrusted || !e.target || !e.target.closest) return;
    var t = e.target, d = null, tekst = '';
    if (t.matches('[data-btol-cs-select]')) {
      d = domeinVan(t); tekst = t.options[t.selectedIndex] ? t.options[t.selectedIndex].text : '';
    } else if (t.matches('select[data-btol-opt]') && t.closest('[data-btol-card]') && maatSelect(t.closest('[data-btol-card]')) === t) {
      d = domeinVan(t); tekst = t.options[t.selectedIndex] ? t.options[t.selectedIndex].text : '';
    } else if (t.closest('variant-picker[context="main_product"]')) {
      var pr = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      d = domeinVanTekst(pr ? pr.type : '');
      if (t.tagName === 'SELECT') tekst = t.options[t.selectedIndex] ? t.options[t.selectedIndex].text : '';
      else if (t.id) { var lb = document.querySelector('label[for="' + t.id + '"]'); tekst = lb ? lb.textContent : ''; }
    }
    tekst = maatTekst(tekst);
    if (!d || !MAAT_RE.test(tekst)) return;
    maatBewaar(d, tekst);
    maatToepassen();
  });
  var pdpGedaan = false, metVariant = /[?&]variant=/.test(location.search);
  function maatToepassen() {
    /* trechter en suggestiekaartjes in de winkelwagen */
    document.querySelectorAll('[data-btol-cs-select]').forEach(function (s) {
      var d = domeinVan(s), t = maatLees(d);
      if (t && d === 'dekbed') t = dekbedVoorkeur(t);
      if (t && !maatOk(s, t)) kiesMaat(s, t);
    });
    /* 'Maak je set compleet' op de productpagina */
    document.querySelectorAll('[data-btol-card]').forEach(function (card) {
      var sel = maatSelect(card); if (!sel) return;
      var d = domeinVan(sel), t = maatLees(d);
      if (t && d === 'dekbed') t = dekbedVoorkeur(t);
      if (!t || maatOk(sel, t)) return;
      var hit = besteMaat(Array.prototype.slice.call(sel.options), optTekst, t);
      if (!hit) return;
      sel.value = hit.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
    /* productpagina zelf: een keer bij het openen, niet als er al een variant in de link staat (bv. vanuit Google) */
    if (!pdpGedaan && !metVariant) {
      var vp = document.querySelector('variant-picker[context="main_product"]');
      var pr = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      if (vp && pr) {
        pdpGedaan = true;
        var pd = domeinVanTekst(pr.type), t = maatLees(pd);
        if (!t) return;
        if (pd === 'dekbed' && !/overtrek/i.test(pr.type)) t = dekbedVoorkeur(t);
        vp.querySelectorAll('fieldset').forEach(function (f) {
          var radios = Array.prototype.slice.call(f.querySelectorAll('input[type="radio"]'));
          var lab = function (i) { var l = f.querySelector('label[for="' + i.id + '"]'); return l ? maatTekst(l.textContent) : ''; };
          if (!radios.length || !radios.some(function (i) { return MAAT_RE.test(lab(i)); })) return;
          var hit = besteMaat(radios, lab, t);
          if (hit && !hit.checked) hit.click();
        });
        vp.querySelectorAll('select').forEach(function (s) {
          if (!Array.prototype.some.call(s.options, function (o) { return MAAT_RE.test(o.text); }) || maatOk(s, t)) return;
          var o = besteMaat(Array.prototype.slice.call(s.options), optTekst, t);
          if (o) { s.value = o.value; s.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      }
    }
  }
  /* oude sessie-sleutel van de trechter overnemen */
  try { var oud = sessionStorage.getItem('btol_matras'); if (oud && !localStorage.getItem(MAAT_KEY.matras)) maatBewaar('matras', oud); sessionStorage.removeItem('btol_matras'); } catch (err) {}
  var maatBezig = false;
  function maatPlan() { if (maatBezig) return; maatBezig = true; setTimeout(function () { maatBezig = false; maatToepassen(); }, 60); }
  maatToepassen();
  document.addEventListener('DOMContentLoaded', maatPlan);
  document.addEventListener('variant:change', function () { setTimeout(maatPlan, 200); });
  if (window.MutationObserver) new MutationObserver(maatPlan).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- 8. trechter: kleur wisselen met de kleurfotootjes, extra kleuren open- en dichtklappen ---------- */
  function euro(c) { return (c / 100).toFixed(2).replace('.', ','); }
  document.addEventListener('click', async function (e) {
    var meer = e.target.closest && e.target.closest('[data-btol-kleur-meer]');
    if (meer) {
      e.preventDefault();
      var kl = meer.closest('[data-btol-kleuren]'), open = kl.classList.toggle('is-open');
      if (!meer.getAttribute('data-dicht')) meer.setAttribute('data-dicht', meer.textContent);
      meer.textContent = open ? 'Minder kleuren' : meer.getAttribute('data-dicht');
      return;
    }
    var b = e.target.closest && e.target.closest('[data-btol-kleur]');
    if (!b) return;
    e.preventDefault();
    var card = b.closest('[data-btol-cs]');
    if (!card || b.classList.contains('is-actief')) return;
    var sel = card.querySelector('[data-btol-cs-select]');
    var huidig = sel ? sel.options[sel.selectedIndex].text : '';
    card.setAttribute('aria-busy', 'true');
    try {
      var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      var p = await fetch(root + 'products/' + b.getAttribute('data-btol-kleur') + '.js').then(function (r) { return r.json(); });
      var url = root + 'products/' + p.handle;
      card.querySelectorAll('.btol-cs__beeld, .btol-cs__titel').forEach(function (a) { a.setAttribute('href', url); });
      var titel = card.querySelector('.btol-cs__titel'); if (titel) titel.textContent = p.title;
      var img = card.querySelector('.btol-cs__beeld img');
      if (img && p.featured_image) { img.removeAttribute('srcset'); img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240'; img.alt = p.title; }
      var knop = card.querySelector('[data-btol-cs-add]');
      var prijs = card.querySelector('[data-btol-cs-prijs]');
      if (sel) {
        sel.innerHTML = '';
        p.variants.forEach(function (v) {
          var o = document.createElement('option');
          o.value = v.id; o.textContent = v.title + (v.available ? '' : ' (uitverkocht)'); o.disabled = !v.available; o.setAttribute('data-prijs', euro(v.price));
          sel.appendChild(o);
        });
        var eerste = p.variants.find(function (v) { return v.available; }) || p.variants[0];
        sel.value = eerste.id;
        kiesMaat(sel, huidig);
        kaartBij(card, sel);
      } else {
        var v1 = p.variants.find(function (v) { return v.available; }) || p.variants[0];
        if (knop) { knop.setAttribute('data-btol-cs-add', v1.id); knop.disabled = !v1.available; }
        if (prijs) prijs.textContent = euro(v1.price);
      }
      card.querySelectorAll('[data-btol-kleur]').forEach(function (k) { k.classList.toggle('is-actief', k === b); });
    } catch (err) {}
    card.removeAttribute('aria-busy');
  });

  /* ---------- 9. winkelwagen-icoon: aantal stuks in het bolletje ---------- */
  var aantal = null;
  function aantalZet(n) {
    if (typeof n === 'number') aantal = n > 99 ? '99+' : String(n);
    if (aantal === null) return;
    document.querySelectorAll('cart-dot').forEach(function (d) { if (d.getAttribute('data-aantal') !== aantal) d.setAttribute('data-aantal', aantal); });
  }
  function aantalHaal() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { aantalZet(c.item_count); }).catch(function () {});
  }
  aantalHaal();
  document.addEventListener('cart:change', function (e) {
    var c = e.detail && e.detail.cart;
    if (c && typeof c.item_count === 'number') aantalZet(c.item_count); else aantalHaal();
  });
  document.addEventListener('cart:refresh', function () { setTimeout(aantalHaal, 400); });
  if (window.MutationObserver) new MutationObserver(function () { aantalZet(); }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- 10. losse swoosh tussen secties ----------
     Heeft een sectie een andere achtergrondkleur dan de sectie erboven, dan loopt die bovenste kleur in een losse zwaai
     over haar bovenrand (vormen in btol-globaal.css). Vorm en richting per sectie wisselend, maar vast per sectie
     (afgeleid van de sectie-id), zodat het bij herladen niet verspringt. Doorzichtige secties tellen als de pagina (wit). Niet bij de footer.
     Heeft een sectie meerdere gekleurde banden (productverhaal), dan telt elke band apart.
     De sectie krijgt bovenaan extra ruimte, zodat tekst nooit tegen de zwaai plakt. */
  function golfGetal(s) { var x = 0; for (var i = 0; i < s.length; i++) x = (x * 31 + s.charCodeAt(i)) | 0; return Math.abs(x); }
  function golven() {
    var vorige = null, vorm = -1, pagina = getComputedStyle(document.body).backgroundColor;
    if (/,\s*0\)$/.test(pagina) || pagina === 'transparent') pagina = 'rgb(255, 255, 255)';
    document.querySelectorAll('.btol-golf__vlak').forEach(function (v) { v.classList.remove('btol-golf__vlak'); });
    document.querySelectorAll('.btol-golf').forEach(function (v) { v.classList.remove('btol-golf', 'btol-golf--1', 'btol-golf--2', 'btol-golf--3', 'btol-golf--spiegel'); });
    /* blokken: elke sectie, of elke gekleurde band als een sectie er meerdere heeft (zoals het productverhaal) */
    var blokken = [];
    document.querySelectorAll('main .shopify-section, .shopify-section-group-footer-group').forEach(function (s) {
      if (s.offsetHeight < 10) return;
      var footer = s.classList.contains('shopify-section-group-footer-group');
      var banden = s.querySelectorAll('.btol-pv__band');
      if (banden.length > 1) {
        banden.forEach(function (b, i) { if (b.offsetHeight >= 10) blokken.push({ s: b, e: b, id: (s.id || '') + '-' + i, footer: footer }); });
      } else {
        blokken.push({ s: s, e: s.querySelector('.btol-pv__band, .btol-home, .btol-fu, .footer, .color-scheme') || s, id: s.id || '', footer: footer });
      }
    });
    blokken.forEach(function (x) {
      var bg = getComputedStyle(x.e).backgroundColor;
      if (/,\s*0\)$/.test(bg) || bg === 'transparent') bg = pagina;
      if (vorige && vorige !== bg && !x.footer) {
        var n = golfGetal(x.id || String(vorm)), v = n % 3;
        if (v === vorm) v = (v + 1) % 3;
        vorm = v;
        x.s.classList.add('btol-golf', 'btol-golf--' + (v + 1));
        if ((n >> 3) % 2) x.s.classList.add('btol-golf--spiegel');
        x.s.style.setProperty('--btol-golf-boven', vorige);
        /* extra ruimte bovenaan in de eigen kleur: de oorspronkelijke bovenmarge + de hoogte van de zwaai (in btol-globaal.css) */
        x.e.style.setProperty('--btol-golf-pt', getComputedStyle(x.e).paddingTop);
        x.e.classList.add('btol-golf__vlak');
      }
      vorige = bg;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', golven); else golven();
  window.addEventListener('load', golven);
  /* secties die later laden (bv. 'Vaak samen bekeken'): opnieuw rekenen zodra een sectie van grootte verandert */
  if (window.ResizeObserver) {
    var golfT = null;
    var golfRo = new ResizeObserver(function () { clearTimeout(golfT); golfT = setTimeout(golven, 150); });
    var golfKijk = function () { document.querySelectorAll('main .shopify-section').forEach(function (s) { golfRo.observe(s); }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', golfKijk); else golfKijk();
  }

  /* ---------- 11. productpagina: 'Maak je bed compleet', zoals bij Smulders (snippets/btol-pdp-bundel.liquid) ----------
     Onder de maatkeuze een veld in dezelfde stijl; klikken opent een zijlade met de stappen (hoeslaken en matrasbeschermer
     per matrashoogte, dekbed, hoofdkussen). 'Voeg toe' zet een product in je bestelling; onder het veld staat wat gekozen is.
     Maten staan meteen goed (zelf gekozen maat uit het maatgeheugen, anders afgeleid van de maat van het overtrek).
     Wat gekozen is, gaat als extra regels (items[n]) mee in het formulier van de hoofdknop: het thema legt alles in één keer
     in de winkelwagen. Het thema bouwt het productblok opnieuw op bij een andere variant: de keuzes worden daarna teruggezet.
     Gebruik wordt bijgehouden in de bestelling (verborgen kenmerk _bed_compleet, zoals _keuzehulp). */
  function btolLog(tekst) {
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var oud = (c.attributes && c.attributes._bed_compleet) || '';
      var nieuw = (oud ? oud + ' | ' : '') + tekst;
      if (nieuw.length > 1500) nieuw = nieuw.slice(nieuw.length - 1500);
      return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { _bed_compleet: nieuw } }) });
    }).catch(function () {});
  }
  (function () {
    var staat = { aan: {}, maat: {}, aantal: {}, hh: null, stap: null, open: false, bekeken: false };
    function B() { return document.querySelector('[data-btol-bu]'); }
    function L() { return document.querySelector('body > [data-btol-bu-lade]') || document.querySelector('[data-btol-bu] [data-btol-bu-lade]'); }
    function F() { return document.querySelector('form[id^="product-form-main"]'); }
    function sleutel(k) { var a = k.querySelector('.btol-bu__titel'); return a ? a.getAttribute('href') : ''; }
    function varianten(bu) {
      if (!bu.__btolVar) { try { bu.__btolVar = JSON.parse(bu.querySelector('[data-btol-bu-varianten]').textContent); } catch (err) { bu.__btolVar = {}; } }
      return bu.__btolVar;
    }
    function hoofd(bu) { var f = F(), i = f && f.querySelector('[name="id"]'); return i && bu ? varianten(bu)[i.value] : null; }
    function breedte(t) { var d = maatDelen(t); return d ? parseInt(d[0].b[0], 10) || 0 : 0; }
    function matrasMaat(w) { return w <= 160 ? '90 x 200' : w <= 220 ? '140 x 200' : w <= 250 ? '160 x 200' : '180 x 200'; }
    function doelMaat(bu, soort) {
      var h = hoofd(bu), w = h ? breedte(h.t) : 0, mem = maatLees(soort);
      if (soort === 'matras') return mem || (w ? matrasMaat(w) : '');
      if (soort === 'dekbed') return mem ? dekbedVoorkeur(mem) : (w ? w + ' x ' + (w === 200 ? '200' : '220') : '');
      if (soort === 'kussen') return mem || '60 x 70';
      return '';
    }
    function lees(k) {
      var s = k.querySelector('[data-btol-bu-select]'), o = s && s.options[s.selectedIndex], a = k.querySelector('[data-btol-bu-aantal]');
      return { id: s ? s.value : '', p: o ? parseInt(o.getAttribute('data-prijs'), 10) || 0 : 0, n: a ? parseInt(a.value, 10) || 1 : 1, uit: !o || o.disabled, maat: o && s.options.length > 1 ? maatTekst(o.text) : '' };
    }
    function toonPrijs(k) { var x = lees(k), el = k.querySelector('[data-btol-bu-prijs]'); if (el) el.textContent = euro(x.p * x.n); }
    function items() { var l = L(); return l ? Array.prototype.slice.call(l.querySelectorAll('[data-btol-bu-item]')) : []; }
    function gekozen() { return items().filter(function (k) { var t = k.querySelector('[data-btol-bu-toggle]'); return t && t.getAttribute('aria-pressed') === 'true'; }); }
    function zetMaten(bu) {
      items().forEach(function (k) {
        var key = sleutel(k), s = k.querySelector('[data-btol-bu-select]'), a = k.querySelector('[data-btol-bu-aantal]');
        if (s && staat.maat[key]) s.value = staat.maat[key];
        else if (s && s.options.length > 1) {
          var doel = doelMaat(bu, k.getAttribute('data-soort')), opts = Array.prototype.slice.call(s.options);
          var o = doel && (besteMaat(opts, optTekst, doel) || dichtsteMaat(opts, doel));
          if (o) s.value = o.value;
        }
        if (a) { if (staat.aantal[key]) a.value = staat.aantal[key]; else { var h = hoofd(bu); a.value = h && breedte(h.t) >= 200 ? '2' : '1'; } }
        toonPrijs(k);
      });
      toonDekbedden(bu);
    }
    /* dekbedden: eerst de dekbedden die in de maat van het overtrek bestaan (bv. 270 x 220 alleen bij Carlina), daarna de rest; er staan er 3 zichtbaar (een gekozen dekbed blijft altijd zichtbaar) */
    function toonDekbedden(bu) {
      var l = L(), p = l && l.querySelector('[data-btol-bu-paneel="dekbed"]');
      if (!p) return;
      var doel = doelMaat(bu, 'dekbed'), ks = Array.prototype.slice.call(p.querySelectorAll('[data-btol-bu-item]'));
      var past = ks.filter(function (k) { var s = k.querySelector('[data-btol-bu-select]'); return s && doel && besteMaat(Array.prototype.slice.call(s.options), optTekst, doel); });
      past.concat(ks.filter(function (k) { return past.indexOf(k) < 0; })).forEach(function (k, i) {
        var aan = k.querySelector('[data-btol-bu-toggle]').getAttribute('aria-pressed') === 'true';
        k.style.display = i >= 3 && !aan ? 'none' : '';
        p.appendChild(k);
      });
    }
    /* geen exacte maat (bv. overtrek 270 breed, dekbed bestaat tot 260): de dichtstbijzijnde breedte, liefst met dezelfde lengte */
    function dichtsteMaat(lijst, t) {
      var d = maatDelen(t); if (!d) return null;
      var tw = parseInt(d[0].b[0], 10) || 0, tl = d[0].l, beste = null, bs = 1e9;
      lijst.forEach(function (o) {
        if (o.disabled) return;
        var m = maatDelen(o.text); if (!m) return;
        var sc = Math.abs((parseInt(m[0].b[0], 10) || 0) - tw) * 10 + (m[0].l.some(function (x) { return tl.indexOf(x) > -1; }) ? 0 : 5);
        if (sc < bs) { bs = sc; beste = o; }
      });
      return beste;
    }
    /* klant kiest zelf een maat op een kaartje: de andere kaartjes van hetzelfde soort (hoeslaken/beschermer, dekbed, kussen) gaan mee */
    function volgMaat(bron, tekst) {
      var soort = bron.getAttribute('data-soort');
      items().forEach(function (k) {
        if (k === bron || k.getAttribute('data-soort') !== soort) return;
        var s = k.querySelector('[data-btol-bu-select]'); if (!s || s.options.length < 2) return;
        var opts = Array.prototype.slice.call(s.options), o = besteMaat(opts, optTekst, maatTekst(tekst)) || dichtsteMaat(opts, maatTekst(tekst));
        if (o) { s.value = o.value; staat.maat[sleutel(k)] = o.value; toonPrijs(k); }
      });
    }
    function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function som() {
      var bu = B(), f = F(), l = L();
      if (!bu || !f) return;
      var h = hoofd(bu), q = f.querySelector('[name="quantity"]'), n = q ? parseInt(q.value, 10) || 1 : 1;
      var g = gekozen(), extra = 0;
      g.forEach(function (k) { var x = lees(k); extra += x.p * x.n; });
      var tot = (h ? h.p * n : 0) + extra;
      /* overzicht onder het veld */
      var ul = bu.querySelector('[data-btol-bu-gekozen]');
      if (ul) {
        ul.innerHTML = g.map(function (k) {
          var x = lees(k), beeld = k.getAttribute('data-beeld');
          return '<li><span class="btol-bu__mini">' + (beeld ? '<img src="' + esc(beeld) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="btol-bu__regel"><strong>' + esc(k.getAttribute('data-naam') || '') + '</strong><small>' + esc(k.getAttribute('data-stap') || '') + (x.maat ? ' · ' + esc(x.maat) : '') + (x.n > 1 ? ' · ' + x.n + ' stuks' : '') + '</small></span>' +
            '<span class="btol-bu__regelprijs">' + euro(x.p * x.n) + '</span>' +
            '<button type="button" class="btol-bu__weg" data-btol-bu-weg="' + esc(sleutel(k)) + '" aria-label="Verwijder ' + esc(k.getAttribute('data-naam') || '') + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></li>';
        }).join('');
        ul.hidden = !g.length;
      }
      var tel = g.length === 1 ? '1 extra' : g.length + " extra's";
      var el = bu.querySelector('[data-btol-bu-som]');
      if (el) {
        el.hidden = !g.length;
        bu.querySelector('[data-btol-bu-telling]').textContent = 'Je ' + (bu.getAttribute('data-hoofd') || 'overtrek') + ' + ' + tel + ', samen';
        bu.querySelector('[data-btol-bu-totaal]').textContent = euro(tot);
      }
      var veld = bu.querySelector('[data-btol-bu-open] small');
      if (veld) veld.textContent = g.length ? tel + ' toegevoegd' : (veld.getAttribute('data-leeg') || 'Bijpassende hoeslakens, dekbed en kussens');
      /* voet van de lade */
      if (l) {
        var lt = l.querySelector('[data-btol-bu-lade-telling]'), lb = l.querySelector('[data-btol-bu-lade-totaal]');
        if (lt) lt.textContent = g.length ? tel + ' toegevoegd, samen met je ' + (bu.getAttribute('data-hoofd') || 'overtrek') : 'Nog niets toegevoegd';
        if (lb) lb.textContent = g.length ? euro(tot) : '';
        l.querySelectorAll('[data-btol-bu-stap-knop]').forEach(function (b) {
          var p = l.querySelector('[data-btol-bu-paneel="' + b.getAttribute('data-btol-bu-stap-knop') + '"]');
          b.classList.toggle('is-gekozen', g.some(function (k) { return p && p.contains(k); }));
        });
      }
      /* extra regels in het formulier van de hoofdknop */
      f.querySelectorAll('input[data-btol-bu-veld]').forEach(function (i) { i.remove(); });
      var nr = 0;
      g.forEach(function (k) {
        var x = lees(k);
        if (!x.id || x.uit) return;
        [['id', x.id], ['quantity', x.n]].forEach(function (v) {
          var i = document.createElement('input');
          i.type = 'hidden'; i.name = 'items[' + nr + '][' + v[0] + ']'; i.value = v[1]; i.setAttribute('data-btol-bu-veld', '');
          f.appendChild(i);
        });
        nr++;
      });
    }
    function naarStap(st) {
      var l = L(); if (!l || !l.querySelector('[data-btol-bu-paneel="' + st + '"]')) return;
      staat.stap = st;
      l.querySelectorAll('[data-btol-bu-paneel]').forEach(function (p) { p.classList.toggle('is-actief', p.getAttribute('data-btol-bu-paneel') === st); });
      l.querySelectorAll('[data-btol-bu-stap-knop]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-btol-bu-stap-knop') === st ? 'true' : 'false'); });
      var body = l.querySelector('.btol-bu__ladebody'); if (body) body.scrollTop = 0;
    }
    /* matrashoogte (S = tot 25 cm, X = hoog, T = topper): geldt voor hoeslakens en matrasbeschermers samen */
    function kiesHoogte(g, zelf) {
      var l = L(), ok = false;
      if (!l) return;
      l.querySelectorAll('[data-btol-bu-paneel]').forEach(function (p) {
        if (!p.querySelector('[data-btol-bu-opt="' + g + '"]')) return;
        ok = true;
        p.querySelectorAll('[data-btol-bu-opt]').forEach(function (o) { o.classList.toggle('is-actief', o.getAttribute('data-btol-bu-opt') === g); });
        var s = p.querySelector('[data-btol-bu-hoogte]'); if (s && s.value !== g) s.value = g;
      });
      if (!ok) return;
      staat.hh = g;
      if (zelf) { try { localStorage.setItem('btol_ups', g); } catch (err) {} }
    }
    function open() {
      var l = L(); if (!l) return;
      staat.open = true; staat.bekeken = true;
      l.hidden = false;
      document.documentElement.classList.add('btol-bu-open');
      requestAnimationFrame(function () { requestAnimationFrame(function () { l.classList.add('is-open'); }); });
      var x = l.querySelector('.btol-bu__sluit'); if (x) setTimeout(function () { x.focus(); }, 300);
    }
    function sluit() {
      var l = L(); if (!l) return;
      staat.open = false;
      l.classList.remove('is-open');
      document.documentElement.classList.remove('btol-bu-open');
      setTimeout(function () { if (!staat.open) l.hidden = true; }, 300);
      var v = document.querySelector('[data-btol-bu-open]'); if (v) v.focus();
    }
    /* (opnieuw) klaarzetten: bij het openen en telkens als het thema het blok vervangt */
    function klaar() {
      var bu = B();
      if (!bu || bu.__btolKlaar) return;
      bu.__btolKlaar = true;
      var nieuw = bu.querySelector('[data-btol-bu-lade]');
      if (nieuw) {
        /* de lade naar het einde van de pagina, zodat ze altijd boven alles ligt */
        document.querySelectorAll('body > [data-btol-bu-lade]').forEach(function (o) { o.remove(); });
        document.body.appendChild(nieuw);
        if (staat.open) { nieuw.hidden = false; nieuw.classList.add('is-open'); }
      }
      var g0 = staat.hh;
      if (!g0) { try { g0 = localStorage.getItem('btol_ups'); } catch (err) {} }
      if (g0) kiesHoogte(g0, false);
      items().forEach(function (k) { if (staat.aan[sleutel(k)]) k.querySelector('[data-btol-bu-toggle]').setAttribute('aria-pressed', 'true'); });
      if (staat.stap) naarStap(staat.stap);
      zetMaten(bu);
      som();
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-btol-bu-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-btol-bu-sluit]')) { e.preventDefault(); sluit(); return; }
      var w = e.target.closest('[data-btol-bu-weg]');
      if (w) {
        var key = w.getAttribute('data-btol-bu-weg');
        items().forEach(function (k) { if (sleutel(k) === key) k.querySelector('[data-btol-bu-toggle]').setAttribute('aria-pressed', 'false'); });
        staat.aan[key] = false; som(); return;
      }
      var t = e.target.closest('[data-btol-bu-toggle]');
      if (t) {
        var aan = t.getAttribute('aria-pressed') !== 'true', k = t.closest('[data-btol-bu-item]');
        t.setAttribute('aria-pressed', aan ? 'true' : 'false');
        staat.aan[sleutel(k)] = aan;
        som(); return;
      }
      var s = e.target.closest('[data-btol-bu-stap-knop]');
      if (s) naarStap(s.getAttribute('data-btol-bu-stap-knop'));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && staat.open) sluit(); });
    document.addEventListener('change', function (e) {
      if (!e.target.closest) return;
      if (e.target.matches('[data-btol-bu-hoogte]')) { kiesHoogte(e.target.value, true); return; }
      var k = e.target.closest('[data-btol-bu-item]');
      if (k) {
        var key = sleutel(k);
        if (e.target.matches('[data-btol-bu-aantal]')) staat.aantal[key] = e.target.value;
        else if (e.target.matches('[data-btol-bu-select]')) {
          staat.maat[key] = e.target.value;
          var o = e.target.options[e.target.selectedIndex];
          if (o) { maatBewaar(k.getAttribute('data-soort'), o.text); volgMaat(k, o.text); }
        }
        toonPrijs(k);
      }
      if (B()) setTimeout(som, 0);
    });
    document.addEventListener('variant:change', function () { setTimeout(function () { var bu = B(); if (bu) { klaar(); zetMaten(bu); som(); } }, 60); });
    /* vlak voor het toevoegen nog eens de extra regels goed zetten */
    document.addEventListener('submit', function (e) { if (e.target && e.target.matches && e.target.matches('form[id^="product-form-main"]')) som(); }, true);
    /* na toevoegen met de hoofdknop: bijhouden in de bestelling, daarna de keuzes leegmaken (niets twee keer) */
    document.addEventListener('variant:add', function (e) {
      if (!e.target || !e.target.matches || !e.target.matches('form[id^="product-form-main"]')) return;
      var bu = B(); if (!bu) return;
      var g = gekozen(), h = hoofd(bu);
      if (g.length || staat.bekeken) {
        var bij = (bu.getAttribute('data-titel') || '') + (h ? ' ' + maatTekst(h.t) : '');
        var wat = g.length ? g.map(function (k) { var x = lees(k); return (k.getAttribute('data-stap') || '') + ': ' + (k.getAttribute('data-naam') || '') + (x.maat ? ' ' + x.maat : '') + (x.n > 1 ? ' (' + x.n + 'x)' : ''); }).join('; ') : 'bekeken, niets toegevoegd';
        btolLog('Productpagina bij ' + bij + ': ' + wat);
      }
      staat.aan = {}; staat.bekeken = false;
      items().forEach(function (k) { k.querySelector('[data-btol-bu-toggle]').setAttribute('aria-pressed', 'false'); });
      som();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', klaar); else klaar();
    if (window.MutationObserver) {
      var kT = null;
      new MutationObserver(function () { var bu = B(); if (bu && !bu.__btolKlaar) { clearTimeout(kT); kT = setTimeout(klaar, 30); } }).observe(document.documentElement, { childList: true, subtree: true });
    }
  })();
})();
